import View from '@/base/views/view';

class ErrorSignatureView extends View {

    static table = 'errorsignature';

    static options () {
        let obj = {
            fields: [
                { name: 'Message', label: 'Mensaje', hideIf: () => true, headerField: true, maxLength: 255 },
                { name: 'Status', label: 'Estado', hideIf: () => true, headerField: true },
                { name: 'LastSeen', label: 'Última vez visto', hideIf: () => true, headerField: true },
                { name: 'Data', editor: 'component', component:'ErrorLogsEditModal', componentPath: 'components/errorlogs',
                    componentName: 'ErrorLogsEditModal', hideFromList: true, active: true },
                { name: 'tab3', label: 'Email Preview', editor: 'component', component:'ErrorLogsPreviewTable', componentPath: 'components/errorlogs',
                    componentName: 'ErrorLogsPreviewTable', hideFromList: true },
            ]
        }
        return obj;
    }

    static async getTableOptions () {
        let res = await super.getTableOptions(this.options());
        res.evalDelete  = (record) => false
        res.evalEdit  = (record) => false
        return res;
    }

}

export default ErrorSignatureView;